/** Masque les origines de test (ne pas les afficher aux administrateurs). */
export function isLocalDevOrigin(origin: string) {
  return /localhost|127\.0\.0\.1/i.test(origin);
}

/** Nom de domaine affiché (priorité au champ saisi par l’admin). */
export function displayPublicSiteHost(origin: string, configured?: string | null) {
  const cfg = configured?.trim();
  if (cfg) {
    try {
      const u = cfg.startsWith('http') ? new URL(cfg) : new URL(`https://${cfg}`);
      return u.host;
    } catch {
      return cfg.replace(/^https?:\/\//i, '').split('/')[0];
    }
  }
  if (!origin?.trim() || isLocalDevOrigin(origin)) return null;
  try {
    return new URL(origin).host;
  } catch {
    return origin;
  }
}
